import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import React from 'react';
import { WidgetStrategyWithStreamByRequestUid } from 'widgets/WidgetRegistry';
import { VenueExecCapsule } from 'widgets/venueAnalysis/capsules/venueExecCapsule/components/VenueExecCapsule';

import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { VenueExecCapsuleMyPortfolioCapsuleContent } from 'widgets/venueAnalysis/capsules/venueExecCapsule/components/VenueExecCapsuleMyPortfolioCapsuleContent';
import { VenueAnalysisByOrderIdsOrSymbolStreamRequest } from 'widgets/venueAnalysis/api/VenueAnalysisByOrderIdsOrSymbolStreamRequest';
import VenueExecCapsuleSettings from './components/settings/VenueExecCapsuleSettings';

import { venueAnalysisStreamedDataSelectors } from 'widgets/venueAnalysis/store/stream/streamSlice';
import { venueExecCapsuleDescription } from 'widgets/venueAnalysis/capsules/venueExecCapsule/components/description/venueExecCapsuleDescription';
import {
    initialVenueAnalysisCapsuleConfigState,
    VenueAnalysisCapsuleConfigState,
} from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
import { venueAnalysisStreamConfig } from 'widgets/venueAnalysis/store/stream/stream-config';

const useMessagesInMyPortfolioCapsules = (symbol: string) =>
    venueAnalysisStreamedDataSelectors.useStreamedDataMessages(
        symbol,
        initialVenueAnalysisCapsuleConfigState
    );

export const venueExecCapsuleStrategy: MyPortfolioCapsuleWidgetStrategyWithConfig<VenueAnalysisCapsuleConfigState> &
    WidgetStrategyWithStreamByRequestUid<VenueAnalysisByOrderIdsOrSymbolStreamRequest> =
    {
        title: 'Fills by Venue',
        supportedHosts: ['tile'],
        reactComponentType: VenueExecCapsule,
        myPortfolioCapsuleContentReactComponentType:
            VenueExecCapsuleMyPortfolioCapsuleContent,
        categories: [WidgetCategory.FILL_CAPSULES],
        description: venueExecCapsuleDescription,
        initialConfigState: initialVenueAnalysisCapsuleConfigState,
        supportsMyPortfolioCapsule: true,
        supportsMyPortfolioCapsuleConfig: true,
        renderSettingsBody,
        managedStreamConfig: venueAnalysisStreamConfig,
        portfolioSelectionRequirements:
            PortfolioSelectionRequirements.PositionFromAtLeastOneOrder,
        portfolioSelectionRequirementsWithoutOrdersStream:
            PortfolioSelectionRequirements.SingleSymbol,
        useMessagesInMyPortfolioCapsules,
        wideTitle: true,
    };

function renderSettingsBody(
    config: VenueAnalysisCapsuleConfigState,
    onChange: (configDelta: Partial<VenueAnalysisCapsuleConfigState>) => void
) {
    return <VenueExecCapsuleSettings config={config} onChange={onChange} />;
}
